import React, { Component } from 'react';
import { Form, FormSpy } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import PropTypes from 'prop-types';
import './ScheduleEF.less';
import _ from 'lodash';

import ScheduleEFPriorityCreditorForm from './ScheduleEFPriorityCreditorForm';
import ScheduleEFNonPriorityCreditorForm from './ScheduleEFNonPriorityCreditorForm';
import currencyConversion from '../../utils/currencyConversion';
import PagedFieldArray from '../common/PagedFieldArray';
import { Tab, Tabs } from 'react-bootstrap';

function confirm_remove_creditor() {
  return confirm('Remove this creditor?');
}

function confirm_move_creditor() {
  return confirm('Move / renumber this creditor?');
}

class ScheduleEFForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    schedule: PropTypes.any.isRequired,
    isDraft: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: () => null,
  };

  initialValues() {
    const vals = _.cloneDeep(this.props.schedule.data || { priority_creditors: [], non_priority_creditors: [] });
    vals.priority_creditors.forEach((cred) => {
      cred.priority_amount = currencyConversion.toDollarsOrStr(cred.priority_amount);
      cred.total_claim = currencyConversion.toDollarsOrStr(cred.total_claim);
    });
    vals.non_priority_creditors.forEach((cred) => {
      cred.total_claim = currencyConversion.toDollarsOrStr(cred.total_claim);
    });
    return vals;
  }

  render = () => (
    <Form
      initialValues={this.initialValues()}
      onSubmit={this.props.onSubmit}
      mutators={{
        ...arrayMutators,
      }}
      subscription={{}} // optimization for large number of creditors
      render={({ handleSubmit, pristine, form }) => (
        <form onSubmit={handleSubmit} id="parser-schedule-ef-form">
          <Tabs id="creditor-type-tabs">
            <Tab eventKey={1} title="Priority creditors">
              <div id="priority-creditors" className="ir-search-double">
                <PagedFieldArray
                  name="priority_creditors"
                  item={({ fields, name, index }) => (
                    <div style={{ borderBottom: '1px solid gray', marginBottom: 8 }}>
                      <ScheduleEFPriorityCreditorForm
                        index={index}
                        creditor={name}
                        onRemove={() => confirm_remove_creditor() && fields.remove(index)}
                        onMoveUp={index > 0 && (() => confirm_move_creditor() && fields.swap(index, index - 1))}
                        onMoveDown={
                          index < fields.length - 1 && (() => confirm_move_creditor() && fields.swap(index, index + 1))
                        }
                        onAdd={() => {
                          const creditors = [...form.getState().values.priority_creditors];
                          creditors.splice(index, 0, {});
                          form.change('priority_creditors', creditors);
                          // for some reason this leads to uneditable form fields
                          // fields.insert(index, {});
                        }}
                      />
                    </div>
                  )}
                  after={() => (
                    <div className="editable">
                      <button
                        className="btn btn-success"
                        type="button"
                        onClick={() => form.mutators.push('priority_creditors', {})}
                      >
                        Add priority creditor
                      </button>
                    </div>
                  )}
                />
              </div>
            </Tab>
            <Tab eventKey={2} title="Nonpriority creditors">
              <div id="nonpriority-creditors" className="ir-search-double">
                <PagedFieldArray
                  name="non_priority_creditors"
                  subscription={{}}
                  item={({ fields, name, index }) => (
                    <div style={{ borderBottom: '1px solid gray', marginBottom: 8 }}>
                      <ScheduleEFNonPriorityCreditorForm
                        index={index}
                        creditor={name}
                        onRemove={() => confirm_remove_creditor() && fields.remove(index)}
                        onMoveUp={index > 0 && (() => confirm_move_creditor() && fields.swap(index, index - 1))}
                        onMoveDown={
                          index < fields.length - 1 && (() => confirm_move_creditor() && fields.swap(index, index + 1))
                        }
                        onAdd={() => {
                          const creditors = [...form.getState().values.non_priority_creditors];
                          creditors.splice(index, 0, {});
                          form.change('non_priority_creditors', creditors);
                          // for some reason this leads to uneditable form fields
                          // fields.insert(index, {});
                        }}
                      />
                    </div>
                  )}
                  after={() => (
                    <div className="editable">
                      <button
                        className="btn btn-success"
                        type="button"
                        onClick={() => form.mutators.push('non_priority_creditors', {})}
                      >
                        Add non-priority creditor
                      </button>
                    </div>
                  )}
                />
              </div>
            </Tab>
          </Tabs>
          <FormSpy
            subscription={{
              submitting: true,
              pristine: true,
              values: true, // needed for `pristine` to properly work (in some? cases)
            }}
          >
            {({ submitting, pristine }) => (
              <div className="buttons">
                {/*<pre>{JSON.stringify({ pristine }, null, 2)}</pre>*/}
                <button
                  type="submit"
                  disabled={submitting || (pristine && !this.props.isDraft)}
                  className="btn btn-primary"
                >
                  Submit Changes
                </button>

                <button
                  type="button"
                  onClick={() => {
                    if (
                      pristine ||
                      confirm(
                        'You are about to lose unsaved changes!\nPress "Cancel" to continue editing, "OK" to discard changes!'
                      )
                    )
                      this.props.onCancel();
                  }}
                  disabled={submitting}
                  className={`btn btn-link ${pristine ? '' : 'cancel-link'}`}
                >
                  {pristine ? 'Cancel Editing' : 'Discard Changes'}
                </button>
              </div>
            )}
          </FormSpy>
        </form>
      )}
    />
  );
}

export default ScheduleEFForm;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_ef/ScheduleEFForm.jsx